module.exports = __webpack_public_path__ + "img/ssyx_00.8d0ee940.jpg";